import { IOptions } from '@repo/ui';
import { SEX } from 'domain/value-objects';

export const sexOptions: IOptions[] = [
  {
    label: 'Masculino',
    value: SEX.MALE,
  },
  {
    label: 'Feminino',
    value: SEX.FEMALE,
  },
];
